import React, { useCallback, useEffect, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import config from '../../config';
import logoCompact from '../../img/logo-2.svg';
import { Container, Content, NameLetterIcon, UserContent } from './styles';
import { useHistory } from 'react-router-dom';
import { actions as studentActions } from '../../redux/modules/student';

function Top() {
  const dispatch = useDispatch();
  const {
    student: { user },
  } = useSelector((state: any) => state);

  const { foto, name } = user || {};

  useEffect(() => {
    const getUsarData = JSON.parse(localStorage.getItem('persist:root') || '{}');
    if (getUsarData) {
      const {
        user: { id_profile },
      } = JSON.parse(getUsarData.auth || '{}');
      if (id_profile) dispatch(studentActions.fetchStudentsById(id_profile));
    }
  }, [dispatch]);

  const history = useHistory();

  const handleGoToProfile = useCallback(() => {
    history.push('/user');
  }, [history]);

  return useMemo(
    () => (
      <Container>
        <Content>
          <img src={logoCompact} alt="ART" className="logo" />
          <form>
            <fieldset>
              <legend>Formulário de pesquisa</legend>
              <label htmlFor="searchTerm">Termo</label>
              <input type="text" name="searchTerm" id="searchTerm" placeholder="Pesquisar..." />
            </fieldset>
          </form>
        </Content>
        <UserContent onClick={handleGoToProfile}>
          {foto ? (
            <div
              style={{
                backgroundImage: `url(${config.s3Url + foto})`,
              }}
            />
          ) : (
            <NameLetterIcon>{name?.slice(0, 1)}</NameLetterIcon>
          )}
        </UserContent>
      </Container>
    ),
    [foto, name, handleGoToProfile]
  );
}

export default connect()(Top);
